// extracted by mini-css-extract-plugin
export default {"cls1":"STqCkZQLea2d22o3MQTP","cls2":"qg7ym_j8GIU_mLQsCsWw STqCkZQLea2d22o3MQTP"};